module.exports = __webpack_public_path__ + "static/media/urineCulture.6226e7f5.png";